<template>
  <div class="about">
    <h1>Sorry, this page is not here :(</h1>
  </div>
</template>
